import React from 'react';
import { Route, Switch } from 'react-router';

import NotFound from '@swf/components/StarsModal/NotFound';

import { ModalRoutes as Routes } from '../../types/common';
import ActionsModal from '../Club/Members/ActionsModal/ActionsModal';
import CreateCashGame from '../CreateGame/CreateCashGame';
import CreateCashGameSuccess from '../CreateGame/Success/CreateCashGameSuccess';
import CreateTournament from '../CreateTournament/CreateTournament';
import CreateTournamentSuccess from '../CreateTournament/CreateTournamentSuccess/CreateTournamentSuccess';
import DeleteGamePrompt from '../GameTile/DeleteGame/DeleteGamePrompt';
import DeleteAnnouncementPrompt from '../Modal/DeleteAnnouncement/DeleteAnnouncementPrompt';
import DeleteThread from '../Modal/DeleteThread/DeleteThread';
import NotificationModal from '../Modal/Notification/Notification';
import { CreateClub } from '../MyClubs/CreateClub/CreateClub';
import { CreateClubSuccess } from '../MyClubs/CreateClub/components/CreateClubSuccess/CreateClubSuccess';
import { JoinClub } from '../MyClubs/JoinClub/JoinClub';
import NewUser from '../OnBoarding/NewUser';

const HomeGamesModalRoutes: React.FC = () => (
  <Switch>
    <Route path={Routes.createCashGameSuccess} component={CreateCashGameSuccess} />
    <Route path={Routes.createCashGame} component={CreateCashGame} />
    <Route path={Routes.createTournamentSuccess} component={CreateTournamentSuccess} />
    <Route path={Routes.createTournament} component={CreateTournament} />
    <Route path={Routes.onBoardingNewUser} component={NewUser} />
    <Route path={Routes.deleteGamePrompt} component={DeleteGamePrompt} />
    <Route path={Routes.deleteAnnouncementPrompt} component={DeleteAnnouncementPrompt} />
    <Route path={Routes.deleteThreadPrompt} component={DeleteThread} />
    <Route path={Routes.createClubSuccess} component={CreateClubSuccess} />
    <Route path={Routes.createClub} component={CreateClub} />
    <Route path={Routes.joinClub} component={JoinClub} />
    <Route path={Routes.membersAdminActions} component={ActionsModal} />
    <Route path={Routes.notification} component={NotificationModal} />
    <Route component={NotFound} />
  </Switch>
);

export default HomeGamesModalRoutes;
